module.exports = __webpack_public_path__ + "static/media/tip_text_dog_temperature_en.84f4aaf1.svg";